import { InfoBox } from '@/components/sv/info-box'
import { H3 } from '@/components/sv/typographies'
import { CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const WebhookDetailsSectionFallback = () => (
  <>
    <CardHeader className="py-6">
      <H3>Details</H3>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid gap-y-4 gap-x-6 text-sm grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        <InfoBox label="Status" value={<Skeleton className="h-5.5 w-20" />} />
        <InfoBox
          label="Endpoint"
          value={<Skeleton className="h-6 w-28 rounded-md" />}
        />
        <InfoBox
          label="Description"
          value={<Skeleton className="h-5.5 w-55" />}
        />
        <InfoBox
          label="Allowed events"
          value={<Skeleton className="h-5.5 w-45" />}
        />
        <InfoBox
          label="Signing secret"
          value={<Skeleton className="h-6 w-full rounded-md" />}
        />
        <InfoBox
          label="ID"
          value={<Skeleton className="h-6 w-full rounded-md" />}
        />
        <InfoBox label="Created" value={<Skeleton className="h-5.5 w-40" />} />
        <InfoBox label="Updated" value={<Skeleton className="h-5.5 w-40" />} />
      </div>
    </CardContent>
  </>
)
